import styled from 'styled-components';
import LoadsRow from './LoadsRow';

export default styled(LoadsRow)`
  width: 100%;
  background: var(--white);
  display: flex;
  justify-content: space-between;
  padding: 0.8rem 1.6rem;
  border-bottom: 1px solid var(--grey300);
`;
